import { resetForm } from "../../../../../helpers";

let FormX;

export const storeX = () => {
    FormX = document.querySelector("#formX");

    FormX.elements.save.addEventListener("click", () => {
        if (FormX.reportValidity()) {
            FormX.submit();
        }
    });
};

export const create = (url, title) => {
    resetForm("formX", title, url);
};
